"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CouponPackageTab = _interopRequireDefault(require("./CouponPackageTab.vue"));
var _CouponItemTab = _interopRequireDefault(require("./CouponItemTab.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponPackage',
  components: {
    CouponPackageTab: _CouponPackageTab.default,
    CouponItemTab: _CouponItemTab.default
  },
  data: function data() {
    return {
      activeTab: 'package',
      filterPackageId: null,
      filterPackageName: ''
    };
  },
  methods: {
    switchToItems: function switchToItems(_ref) {
      var id = _ref.id,
        packageName = _ref.packageName;
      this.filterPackageId = id;
      this.filterPackageName = packageName || '';
      this.activeTab = 'item';
    }
  }
};